"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MyEvent {
    constructor() {
        this.listeners = new Set();
        this.add = (listener) => {
            this.listeners.add(listener);
            return () => this.listeners.delete(listener);
        };
        this.dispatch = (...args) => {
            const listeners = [];
            for (const l of this.listeners)
                listeners.push(l);
            listeners.forEach(l => l(() => this.listeners.delete(l), ...args));
        };
        this.dispose = () => this.listeners.clear();
    }
}
exports.default = MyEvent;
//# sourceMappingURL=MyEvent.js.map